import React from 'react';

import { ToggleTip } from '@betterment/samba-react';

export const EditAssumptionsToggleTip: React.FC = () => (
  <ToggleTip>
    <ToggleTip.Trigger iconName="InfoCircle" label="Recommendation information" />
    <ToggleTip.Content side="right" css={{ maxWidth: '300px' }}>
      Our recommendation is based on your financial profile and all connected accounts. For the most accurate
      recommendation, confirm your financial profile and link external accounts in your settings.
    </ToggleTip.Content>
  </ToggleTip>
);
